import { render, staticRenderFns } from "./whitePhone.vue?vue&type=template&id=414c9582&"
import script from "./whitePhone.vue?vue&type=script&lang=js&"
export * from "./whitePhone.vue?vue&type=script&lang=js&"
import style0 from "./whitePhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports